import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-modalerrorinterceptor',
  templateUrl: './modalerrorinterceptor.component.html',
  styleUrls: ['./modalerrorinterceptor.component.scss']
})
export class ModalerrorinterceptorComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public errorData: ModalErrorData) { }

  public appGoneError = false;
  public appSystemError = false;
  public appAudioError = false;
  public errMsg = '';

  ngOnInit(): void {
    this.errMsg = this.errorData.msg;

    if (this.errorData.httpCode === 404 && this.errorData.url.indexOf('/applist/cbitem/') !== -1) {
      this.appGoneError = true;
      if (this.errorData.httpCode === 404 && this.errMsg.indexOf('applist/cbitem/Android%20System: 404 Not Found') !== -1) {
        this.appSystemError = true;
      }
      if (this.errorData.httpCode === 404 && this.errMsg.indexOf('applist/cbitem/Android%20Audio: 404 Not Found') !== -1) {
        this.appAudioError = true;
      }
    }





  }

  copyErrMsg() {
    let msg = '';
    if ((this.errorData.deviceName != null && this.errorData.deviceName !== '')
        || (this.errorData.username != null && this.errorData.username !== '')
    ) {
      msg += this.errorData.deviceName + ' ' + this.errorData.username + '\n';
    }
    msg = msg + this.errorData.url + '\n' + 'ERROR: ' + this.errorData.httpCode;
    this.copyToClipbrd(msg);
  }

  private copyToClipbrd(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}


export class ModalErrorData implements ErrorData {
  deviceName?: string;
  username?: string;
  errorCode?: number;
  msg?: string;
  httpCode?: number;
  url?: string;

  constructor(errorData?: ErrorData) {
    if (!errorData) {
      return;
    }

    Object.assign(this, errorData);
  }
}

export interface ErrorData {
  /** Active device name should be assigned if available */
  deviceName?: string;
  /** Active username name should be assigned if available */
  username?: string;
  errorCode?: number;
  msg?: string;
  httpCode?: number;
  url?: string;
}
